import { RootState } from '@/store/main';

/** @deprecated should not be used unless behind permissions gate - can only be used by admins, no lower roles */
export const selectChannelAdmins = (state: RootState) => state.channelAdmins.admins;
export const selectAdminContacts = (state: RootState) => state.channelAdmins.adminContacts;
export const selectTemporarilyLockedEmails = (state: RootState) => state.channelAdmins.temporarilyLockedEmails;
export const selectWorkingPermissions = (state: RootState) => state.channelAdmins.workingPermissions;
export const selectActiveChannelProducersAndPresenters = (state: RootState) =>
  state.channelAdmins.activeChannelProducersAndPresenters;
